export default "__VITE_ASSET__hraNRvXh__"